import {animateScroll} from "../helpers/animate";

$(document).ready(function () {
    $(document).on('click', '[data-href]', function (e) {
        let additionalHeight, offset, to, additional;
        e.preventDefault();

        to = $(this).data('href');
        additional = $(this).data('href-additional');

        additionalHeight = additional ? $(additional).height() : 0;
        offset = $(to).offset().top - $('.header').height() - additionalHeight;

        if ($(to).length)
            animateScroll($(to), 350, offset);
        else
            document.location.href = to;
    });
});